export default {
  'picky-cats:journey:food-type:wet_food:label': 'Natvoer',
  'picky-cats:journey:food-type:dry_food:label': 'Droogvoer',
  'picky-cats:journey:food-type:snacks:label': 'Snacks',

  'picky-cats:journey:consistency:sauce:label': 'Saus',
  'picky-cats:journey:consistency:sauce:detail': 'Sausmenu, Juicy Filet',
  'picky-cats:journey:consistency:pate:label': 'Paté',
  'picky-cats:journey:consistency:pate:detail': 'Pure Meat, Filet Menu, Meaty Pate',
  'picky-cats:journey:consistency:cream:label': 'Crème',
  'picky-cats:journey:consistency:cream:detail': 'Silky Cream',

  'picky-cats:journey:protein:duck:label': 'Eend',
  'picky-cats:journey:protein:poultry:label': 'Gevogelte',
  'picky-cats:journey:protein:deer:label': 'Hert',
  'picky-cats:journey:protein:chicken:label': 'Kip',
  'picky-cats:journey:protein:rabbit:label': 'Konijn',
  'picky-cats:journey:protein:veal:label': 'Kalf',
  'picky-cats:journey:protein:kangaroo:label': 'Kangoeroe',
  'picky-cats:journey:protein:salmon:label': 'Zalm',
  'picky-cats:journey:protein:turkey:label': 'Kalkoen',
  'picky-cats:journey:protein:tuna:label': 'Tonijn',
  'picky-cats:journey:protein:game:label': 'Wild',
  'picky-cats:journey:protein:beef:label': 'Rund',
  'picky-cats:journey:protein:pork:label': 'Varken',
  'picky-cats:journey:protein:horse:label': 'Paard',

  'picky-cats:journey:age-band:kitten:label': 'Kitten',
  'picky-cats:journey:age-band:kitten:detail': '0–1 jaar',
  'picky-cats:journey:age-band:adultcat:label': 'Volwassen',
  'picky-cats:journey:age-band:adultcat:detail': '1–8 jaar',
  'picky-cats:journey:age-band:seniorcat:label': 'Senior',
  'picky-cats:journey:age-band:seniorcat:detail': 'Vanaf 8 jaar',

  'picky-cats:journey:cat-count:one:label': 'Eén',
  'picky-cats:journey:cat-count:two:label': 'Twee',
  'picky-cats:journey:cat-count:more-than-two:label': 'Meer dan twee',
  'picky-cats:journey:cat-count:feedback:V1:one':
    'Helemaal duidelijk – je kat heeft de voerbak helemaal voor zichzelf.',
  'picky-cats:journey:cat-count:feedback:V1:multiple':
    '2+ katten: Goed om te weten! Katten eten het liefst elk uit hun eigen voerbak – zo hoeven ze niet om hun eten te strijden.',
  'picky-cats:journey:cat-count:feedback:V2:one':
    'Helemaal duidelijk – je kat heeft de voerbak helemaal voor zichzelf.',
  'picky-cats:journey:cat-count:feedback:V2:multiple':
    'Goed om te weten! Katten eten het liefst elk uit hun eigen voerbak – zo hoeven ze niet om hun eten te strijden.',

  'picky-cats:journey:education:serving-temperature:title': 'Hoe serveer je het voer?',
  'picky-cats:journey:education:serving-temperature:option:refrigerated':
    'Rechtstreeks uit de koelkast',
  'picky-cats:journey:education:serving-temperature:option:room-temperature': 'Op kamertemperatuur',
  'picky-cats:journey:education:serving-temperature:option:warmed': 'Licht opgewarmd',
  'picky-cats:journey:education:serving-temperature:feedback:confirmation':
    'Heel goed! Op kamertemperatuur ruikt het voer het sterkst – een feest voor de neus van je kat.',
  'picky-cats:journey:education:serving-temperature:feedback:advice':
    'Kleine tip: Rechtstreeks uit de koelkast ruikt voer bijna nergens naar. Laat het even op kamertemperatuur komen, dan smaakt het meteen beter.',

  'picky-cats:journey:education:bowl-shape:title': 'Uit wat voor voerbak eet je kat?',
  'picky-cats:journey:education:bowl-shape:option:deep-narrow': 'Diep en smal',
  'picky-cats:journey:education:bowl-shape:option:flat-wide': 'Ondiep en breed',
  'picky-cats:journey:education:bowl-shape:option:unsure': 'Weet ik niet zeker',
  'picky-cats:journey:education:bowl-shape:feedback:V1:confirmation':
    'Goed bezig! Een ondiepe, brede voerbak is precies goed. Extra tip: Op een rustige plek smaakt het nog beter.',
  'picky-cats:journey:education:bowl-shape:feedback:V1:advice':
    'Kleine tip: Katten houden van ondiepe, brede voerbakken – in diepe bakken stoten hun gevoelige snorharen tegen de rand. Zet de bak ook op een rustig plekje.',
  'picky-cats:journey:education:bowl-shape:feedback:V2:confirmation':
    'Goed bezig! Een ondiepe, brede voerbak is precies goed.',
  'picky-cats:journey:education:bowl-shape:feedback:V2:advice':
    'Kleine tip: Katten houden van ondiepe, brede voerbakken – in diepe bakken stoten hun gevoelige snorharen tegen de rand.',

  'picky-cats:journey:education:feeding-frequency:title': 'Hoe vaak eet je kat per dag?',
  'picky-cats:journey:education:feeding-frequency:option:once': '1 keer per dag',
  'picky-cats:journey:education:feeding-frequency:option:two-plus': '2 of meer maaltijden',
  'picky-cats:journey:education:feeding-frequency:option:always-available':
    'Altijd voer beschikbaar',
  'picky-cats:journey:education:feeding-frequency:feedback:confirmation':
    'Precies goed! Meerdere kleine maaltijden passen perfect bij het natuurlijke ritme van je kat.',
  'picky-cats:journey:education:feeding-frequency:feedback:advice':
    'Kleine tip: In de natuur vangt je kat meerdere kleine prooien per dag. Twee of meer vaste maaltijden per dag doen je kat echt goed.',

  'picky-cats:journey:education:bowl-location:title': 'Waar staat de voerbak?',
  'picky-cats:journey:education:bowl-location:option:near-litter': 'Bij de kattenbak of prullenbak',
  'picky-cats:journey:education:bowl-location:option:busy-spot': 'Op een drukke plek',
  'picky-cats:journey:education:bowl-location:option:quiet-spot': 'Op een rustige plek',
  'picky-cats:journey:education:bowl-location:feedback:confirmation':
    'Perfect! Op een rustige plek voelt je kat zich veilig – en eet je kat met veel meer plezier.',
  'picky-cats:journey:education:bowl-location:feedback:advice':
    'Kleine tip: Naast de kattenbak of midden in de drukte smaakt het minder lekker. Een rustig plekje voor de voerbak doet wonderen.',

  'picky-cats:journey:tip:bowl:text': 'Ondiepe, brede voerbak – zo blijven de snorharen vrij.',
  'picky-cats:journey:tip:bowl-location:text':
    'Een ondiepe, brede voerbak op een rustige plek – zo eet je kat het liefst.',
  'picky-cats:journey:tip:calm-location:text': 'Rustige voerplek, weg van de kattenbak en drukte.',
  'picky-cats:journey:tip:frequency:text': 'Twee of meer vaste maaltijden per dag.',
  'picky-cats:journey:tip:temperature:text': 'Laat het voer op kamertemperatuur komen.',
  'picky-cats:journey:tip:separate-bowls:text': 'Elke kat heeft een eigen voerbak nodig.',

  'picky-cats:journey:result:V1:heading': 'Profiel klaar!',
  'picky-cats:journey:result:V1:detail':
    'We hebben nu het profiel van je kieskeurige kat – en helpen je passende voeding te vinden.',
  'picky-cats:journey:result:V1:praise': 'Je doet het al helemaal goed!',
  'picky-cats:journey:result:V3:heading': 'Het profiel van je kieskeurige kat is klaar!',
  'picky-cats:journey:result:V3:detail':
    'Kieskeurige katten hebben twee dingen nodig: de juiste manier van voeren én voer dat ze echt lekker vinden. We hebben beide voor je kat op een rij gezet.',
  'picky-cats:journey:result:V3:praise': 'Je voert je kat al helemaal goed!',
  'picky-cats:journey:result:tips:heading': 'Zo voer je je kat nog beter',
  'picky-cats:journey:result:products:heading': 'Onze aanbevelingen voor je kat',
  'picky-cats:journey:result:recommendation:error': 'Je aanbevelingen konden niet worden geladen.',
  'picky-cats:journey:result:recommendation:retry': 'Opnieuw proberen',
  'picky-cats:journey:result:recommendation:empty':
    'Voor deze selectie hebben we op dit moment geen passende producten.',
  'picky-cats:journey:result:cart:add': '{title} aan het winkelmandje toevoegen',
  'picky-cats:journey:result:cart:pending': '{title} wordt aan het winkelmandje toegevoegd',
  'picky-cats:journey:result:cart:completed': '{title} is aan het winkelmandje toegevoegd',
  'picky-cats:journey:result:cart:retry': '{title} opnieuw aan het winkelmandje toevoegen',
  'picky-cats:journey:result:cart:error': 'Toevoegen mislukt. Probeer het opnieuw.',
  'picky-cats:journey:result:handoff': 'Meer passende voeding bekijken',
  'picky-cats:journey:result:handoff:error': 'Het profiel van je kat kon niet worden opgeslagen.',
  'picky-cats:journey:result:handoff:retry': 'Opnieuw proberen',

  'picky-cats:journey:result:V2:praise:heading': 'Je voert je kat al helemaal goed!',
  'picky-cats:journey:result:V2:praise:detail':
    'Je kat is gewoon een kleine fijnproever. Laten we voer vinden dat je kat overtuigt.',
  'picky-cats:journey:result:V2:tricks:heading': 'We hebben een paar handige tips voor je!',
  'picky-cats:journey:result:V2:action:continue': 'Nu aanbevelingen bekijken',
  'picky-cats:journey:result:V2:action:close': 'Begrepen',

  'picky-cats:journey:recommendation:V2:heading': 'Klaar – het profiel van je kat is aangemaakt!',
  'picky-cats:journey:recommendation:V2:detail':
    'Op basis van je antwoorden hebben we een profiel voor je kieskeurige kat aangemaakt en passende voeding uitgezocht.',
  'picky-cats:journey:recommendation:V2:cart:label': 'In het winkelmandje',
  'picky-cats:journey:recommendation:V2:cart:completed-label': 'Toegevoegd',
  'picky-cats:journey:recommendation:V2:cart:retry-label': 'Opnieuw proberen',
};
